import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/ops/log/memminutely/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/ops/log/memminutely/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/ops/log/memminutely/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getHourly = (params, urlParams) => {
  return axios.request({
    url: '/ops/log/memminutely/gethourly/' + params.selectDatetime + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDaily = (params, urlParams) => {
  return axios.request({
    url: '/ops/log/memminutely/getdaily/' + params.selectDatetime + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMonthly = (params, urlParams) => {
  return axios.request({
    url: '/ops/log/memminutely/getmonthly/' + params.selectDatetime + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getYearly = (params, urlParams) => {
  return axios.request({
    url: '/ops/log/memminutely/getyearly/' + params.selectDatetime + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

